import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { getOrCreateSessionId } from '../utils/ids.utils';
import { environment } from '../../../environments/environment';

@Injectable()
export class SessionInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const apiUrl = environment.beBaseUrl;

    if (!req.url.startsWith(apiUrl)) {
      return next.handle(req);
    }
    const sessionId = getOrCreateSessionId();
    return next.handle(
      req.clone({ setHeaders: { 'X-Session-Id': sessionId } }),
    );
  }
}
